module.exports = __webpack_public_path__ + "img/back_24.626f2671.svg";